import { Component } from '@angular/core';

@Component({
  standalone: true,
  imports: [],
  selector: 'ui-chart-card',
  template: `
    <div class="flex flex-col justify-center items-center w-full h-full bg-white p-6 rounded-lg border border-gray-200">
      <ng-content></ng-content>
    </div>
  `,
})
export class ChartCardComponent {}
